
import { createGlobalStyle } from 'styled-components'

export const breakPoints = {
  sm: '@media only screen and (min-width: 600px)',
  md: '@media only screen and (min-width: 900px)',
  lg: '@media only screen and (min-width: 1200px)',
  xl: '@media only screen and (min-width: 1600px)',
};


export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap');
  * {
    margin:0;
    padding:0;
    box-sizing: border-box;
    }
    html {
      font-size: 62.5%;
    }  
  body {
    background: ${({ theme }) => theme.colors.body};    
    color: ${({ theme }) => theme.colors.text};
    font-family: 'Poppins', sans-serif;
    font-size: 2.5rem;
    margin: 0;
  }
  p {
    opacity: 0.89;
    line-height: 1.2;
  }
  img {
    max-width: 100%;
}
`